<app-stepper>
  <cdk-step label="Order info" [completed]="true"><p>Order info step</p></cdk-step>
  <cdk-step label="Billing info" [completed]="true"><p>Billing info step</p></cdk-step>
  <cdk-step label="Patient information" [completed]="false"><p>Patient information step</p></cdk-step>
  <cdk-step label="Clinical history" [completed]="false"><p>Clinical history step</p></cdk-step>
  <cdk-step label="Informed consent" [completed]="false"><p>Informed consent step</p></cdk-step>
  <cdk-step label="Confirm Order" [completed]="false">Confirm Order step</cdk-step>
</app-stepper>
